import Styles from './ChatInput.module.scss'
import { Close } from 'blaze-ui/icons/16'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface ChatImageAttachmentProps {
  imageUrl: string
  onRemove: () => void
}

export const ChatImageAttachment = ({ imageUrl, onRemove }: ChatImageAttachmentProps) => {
  return (
    <div className={Styles.attachment}>
      <img className={Styles.thumbnail} src={imageUrl} alt="Attached content" />
      <IconButton
        aria-label="Remove attachment"
        icon={Close}
        onPress={onRemove}
        size="xs"
        rounded
        className={Styles.removeButton}
      />
    </div>
  )
}
